module.exports = __webpack_public_path__ + "static/media/daibukuan.fa330b00.svg";